import React from 'react'
import './admindashboard.css'
import Swal from 'sweetalert2'
import axios from "axios";
import { useState, useEffect, useMemo } from 'react'
import { BsEye, BsEyeSlash, BsImage } from 'react-icons/bs'
import Loader from '../Loader'
import TRADE_PAIRS from './tradePairs'
import EmailsPanel from './EmailsPanel'
import ComposeModal from './ComposeModal'
import { FaEllipsisH } from "react-icons/fa";
import { MdClose, MdCandlestickChart, MdDeleteSweep } from 'react-icons/md'
import { RxUpload, RxDashboard } from 'react-icons/rx'
import { GiReceiveMoney } from 'react-icons/gi'
import { FiLogOut, FiSearch, FiX, FiRefreshCw, FiUsers, FiDollarSign, FiShield, FiTrendingUp, FiCopy, FiMail } from 'react-icons/fi'

// Backend KYC values are not_submitted | processing | approved | rejected
const KYC_LABELS = { all: 'All', processing: 'Awaiting review', approved: 'Approved', not_submitted: 'Not submitted', rejected: 'Rejected' }
const KYC_BADGE = { processing: 'adm-badge-review', approved: 'adm-badge-verified', rejected: 'adm-badge-rejected', not_submitted: 'adm-badge-pending' }
const kycOf = (user) => (KYC_BADGE[user?.kycStatus] ? user.kycStatus : 'not_submitted')

const usd = (value) => `$${Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`

const Admindashboard = ({ route }) => {

  // Admin API calls carry the admin session token. On 401 the session is dropped and the
  // login form returns; the JSON error body is still handed back so callers finish normally.
  const adminFetch = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      headers: { 'Content-Type': 'application/json', ...(options.headers || {}), 'x-admin-token': localStorage.getItem('adminToken') || '' },
    })
    if (response.status === 401) endAdminSession('Your admin session expired. Please sign in again.')
    return response
  }

  const fetchTraders = async () => {
    try {
      const req = await fetch(`${route}/api/fetchTraders`, {
        headers: { 'Content-Type': 'application/json' }
      })
      const res = await req.json()
      setTraders(res.status === 200 ? res.traders : [])
    } catch {
      setTraders([])
    } finally {
      setLoader(false)
    }
  }

  const fetchUsers = async () => {
    try {
      const req = await adminFetch(`${route}/api/getUsers`, {
        headers: { 'Content-Type': 'application/json' }
      })
      const res = await req.json()
      setUsers(res || [])
    } catch {
      setUsers([])
    } finally {
      setLoader(false)
    }
  }

  // unread inbox count for the sidebar, and plan usage for the compose window
  const fetchEmailSummary = async () => {
    try {
      const res = await (await adminFetch(`${route}/api/admin/inbox/summary`)).json()
      if (res.status === 200) setEmailSummary(res)
    } catch {
      // only informative
    }
  }

  useEffect(() => {
    if (!localStorage.getItem('adminToken')) return
    SetShowFoarm(false)
    setShowDasboard(true)
    setLoader(true)
    fetchUsers()
    fetchTraders()
    fetchEmailSummary()
  }, [])

  // sweet alert function 
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  // Credit / debit / withdrawal-approval emails are sent by the backend as part of each action
  const creditUser = async () => {
    setLoader(true)
    try {
      const res = await (await adminFetch(`${route}/api/fundwallet`, {
        method: 'POST',
        body: JSON.stringify({ amount: userAmount, email: email })
      })).json()
      if (res.status === 'ok') {
        Toast.fire({ icon: 'success', title: `Account credited with $${res.funded} USD` })
        setEmail('')
        setUserAmount('')
        fetchUsers()
      } else {
        Toast.fire({ icon: 'error', title: res.message || 'Could not credit this account' })
      }
    } catch {
      Toast.fire({ icon: 'error', title: 'Something went wrong. Please try again.' })
    } finally {
      setLoader(false)
    }
  }

  const debitUser = async () => {
    setLoader(true)
    try {
      const res = await (await adminFetch(`${route}/api/debitwallet`, {
        method: 'POST',
        body: JSON.stringify({ amount: userAmount, email: email })
      })).json()
      if (res.status === 'ok') {
        Toast.fire({ icon: 'success', title: `Account debited with $${res.funded} USD` })
        setEmail('')
        setUserAmount('')
        fetchUsers()
      } else {
        Toast.fire({ icon: 'error', title: res.error === 'capital cannot be negative' ? 'Amount is more than the user\'s balance' : 'Could not debit this account' })
      }
    } catch {
      Toast.fire({ icon: 'error', title: 'Something went wrong. Please try again.' })
    } finally {
      setLoader(false)
    }
  }

  // takes the user directly: reading email from state here would see the previous
  // selection, because state set in the same click hasn't updated yet
  const approveWithdraw = async (user) => {
    setLoader(true)
    try {
      const res = await (await adminFetch(`${route}/api/getWithdrawInfo`, {
        method: 'POST',
        body: JSON.stringify({ email: user.email })
      })).json()
      if (res.status === 'ok') {
        Toast.fire({ icon: 'success', title: `Withdrawal of $${res.amount} approved and ${user.firstname} notified` })
        fetchUsers()
      } else {
        Toast.fire({ icon: 'error', title: res.message || "User hasn't requested a withdrawal" })
      }
    } catch {
      Toast.fire({ icon: 'error', title: 'Something went wrong. Please try again.' })
    } finally {
      setLoader(false)
    }
  }

  const [showDeleteModal, setShowDeletModal] = useState()
  const [activeEmail, setActiveEmail] = useState('')
  const [showUpgradeModal, setShowUpgradeModal] = useState()
  const [showForm, SetShowFoarm] = useState(true)
  const [showDashboard, setShowDasboard] = useState(false)
  const [users, setUsers] = useState()
  const [loader, setLoader] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()
  const [userAmount, setUserAmount] = useState()
  const [showModal, setShowModal] = useState(false)
  const [showCreateTrader, setShowCreateTrader] = useState(false)
  const [showTraderLogs, setShowTraderLogs] = useState(false)
  const [showEmails, setShowEmails] = useState(false)
  const [emailSummary, setEmailSummary] = useState({ unread: 0, quota: null })
  const [composeTo, setComposeTo] = useState(null)   // recipients when "Send email" is used on a user
  const [showUsers, setShowUsers] = useState(true)
  const [showImage, setShowImage] = useState();
  const [traders, setTraders] = useState([])
  const [activeTrader, setActiveTrader] = useState({

  })
  const [showTraderLogForm, setShowTraderLogForm] = useState(false)
  const [activeTraderId, setActiveTraderId] = useState()
  const [selectedValue] = useState()
  const [debitModal, setDebitModal] = useState(false)
  const [dropdownPos, setDropdownPos] = useState({ top: 0, right: 0 })

  // New state for individual allocations
  const [copyTraders, setCopyTraders] = useState([])
  const [individualAllocations, setIndividualAllocations] = useState({})

  // User Management UI State
  const [activeActionMenu, setActiveActionMenu] = useState(null)
  const [showUserDetailsModal, setShowUserDetailsModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)

  useEffect(() => {
    const handleClickOutside = () => setActiveActionMenu(null);
    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, []);

  // Bulk Action State
  const [bulkAmount, setBulkAmount] = useState('')
  const [bulkType, setBulkType] = useState('profit')

  // Search / filter / sort
  const [userSearch, setUserSearch] = useState('')
  const [kycFilter, setKycFilter] = useState('all')
  const [userSort, setUserSort] = useState('balance-desc')
  const [traderSearch, setTraderSearch] = useState('')

  const allUsers = useMemo(() => users || [], [users])

  const kycCounts = useMemo(() => {
    const counts = { all: allUsers.length, processing: 0, approved: 0, not_submitted: 0, rejected: 0 }
    allUsers.forEach(user => { counts[kycOf(user)] += 1 })
    return counts
  }, [allUsers])

  const copiersByTrader = useMemo(() => {
    const map = {}
    allUsers.forEach(user => { if (user.trader) map[user.trader] = (map[user.trader] || 0) + 1 })
    return map
  }, [allUsers])

  const filteredUsers = useMemo(() => {
    const query = userSearch.trim().toLowerCase()
    const list = allUsers.filter(user => {
      if (kycFilter !== 'all' && kycOf(user) !== kycFilter) return false
      if (!query) return true
      return [user.firstname, user.lastname, `${user.firstname} ${user.lastname}`, user.email, user.username, user.country]
        .some(field => (field || '').toLowerCase().includes(query))
    })
    const byName = (a, b) => `${a.firstname} ${a.lastname}`.localeCompare(`${b.firstname} ${b.lastname}`)
    const sorters = {
      'balance-desc': (a, b) => (b.funded || 0) - (a.funded || 0),
      'balance-asc': (a, b) => (a.funded || 0) - (b.funded || 0),
      'name': byName,
    }
    return [...list].sort(sorters[userSort])
  }, [allUsers, userSearch, kycFilter, userSort])

  const filteredTraders = useMemo(() => {
    const query = traderSearch.trim().toLowerCase()
    if (!query) return traders
    return traders.filter(trader =>
      [trader.firstname, trader.lastname, `${trader.firstname} ${trader.lastname}`, trader.nationality]
        .some(field => (field || '').toLowerCase().includes(query)))
  }, [traders, traderSearch])

  const totalBalance = useMemo(() => allUsers.reduce((sum, user) => sum + Number(user.funded || 0), 0), [allUsers])
  const activeTraderName = useMemo(() => {
    const trader = traders.find(t => t._id === activeTraderId)
    return trader ? `${trader.firstname} ${trader.lastname}` : ''
  }, [traders, activeTraderId])

  const refresh = () => {
    setLoader(true)
    fetchUsers()
    fetchTraders()
    fetchEmailSummary()
  }

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text)
      Toast.fire({ icon: 'success', title: 'Copied' })
    } catch {
      Toast.fire({ icon: 'warning', title: 'Could not copy' })
    }
  }

  const openTraderLogForm = (trader) => {
    setShowTraderLogForm(true)
    setActiveTraderId(trader._id)
    setActiveTrader({})
    setBulkAmount('')
    setBulkType('profit')
    const tradersUsers = allUsers.filter(user => user.trader === trader._id)
    setCopyTraders(tradersUsers)
    const initialAllocations = {}
    tradersUsers.forEach(u => { initialAllocations[u._id] = { amount: '', type: 'profit' } })
    setIndividualAllocations(initialAllocations)
  }

  const endAdminSession = (message) => {
    localStorage.removeItem('adminToken')
    setShowDasboard(false)
    SetShowFoarm(true)
    setUsers([])
    setLoader(false)
    if (message) Toast.fire({ icon: 'warning', title: message })
  }

  const logout = () => endAdminSession();

  const openCreateTrader = () => {
    setShowCreateTrader(true)
    setShowTraderLogs(false)
    setShowUsers(false)
    setShowEmails(false)
  }
  const openTraderLogs = () => {
    setShowTraderLogs(true)
    setShowUsers(false)
    setShowCreateTrader(false)
    setShowEmails(false)
  }

  const openUsers = () => {
    setShowCreateTrader(false)
    setShowTraderLogs(false)
    setShowUsers(true)
    setShowEmails(false)
  }

  const openEmails = () => {
    setShowCreateTrader(false)
    setShowTraderLogs(false)
    setShowUsers(false)
    setShowEmails(true)
  }


  const upgradeUser = async () => {

    setLoader(true)
    const req = await adminFetch(`${route}/api/upgradeUser`,
      {
        method: 'POST',
        headers: {
          'content-Type': 'application/json'
        },
        body: JSON.stringify({
          amount: userAmount, email: activeEmail
        })
      })
    const res = await req.json()
    setLoader(false)
    if (res.status === 'ok') {
      Toast.fire({
        icon: 'success',
        title: `Acoount upgraded by  $${res.funded} USD in profit`
      })
      setShowUpgradeModal(false)
      fetchUsers()
    } else {
      Toast.fire({
        icon: 'error',
        title: `something went wrong`
      })
    }

  }

  const applyBulkAllocation = () => {
    if (!copyTraders || copyTraders.length === 0) return;

    const newAllocations = {};
    copyTraders.forEach(user => {
      newAllocations[user._id] = {
        amount: parseFloat(bulkAmount) || 0,
        type: bulkType
      };
    });
    setIndividualAllocations(newAllocations);

    // Optional: Visual feedback
    // Toast.fire({ icon: 'success', title: 'Applied to all' });
  }

  const updateTraderLog = async () => {
    if (!activeTrader.pair) {
      Toast.fire({ icon: 'warning', title: 'Select a trading pair first' })
      return
    }
    try {
      const date = new Date()
      const today = date.toLocaleDateString()

      // Base master log (optional, but good for trader history)
      const masterTradeLog = {
        ...activeTrader,
        'id': activeTraderId,
        'tradeType': selectedValue || 'profit',
        'date': today
      }

      // Construct distributions array from individualAllocations
      const distributions = copyTraders.map(user => {
        const allocation = individualAllocations[user._id] || {};
        const amount = allocation.amount || 0;
        const type = allocation.type || 'profit';

        return {
          email: user.email,
          amount: amount,
          type: type,
          pair: masterTradeLog.pair || 'Unknown Asset'
        };
      }).filter(dist => dist.amount > 0);

      setLoader(true)

      const req = await adminFetch(`${route}/api/distributeProfit`,
        {
          method: 'POST',
          headers: {
            'content-Type': 'application/json',
          },
          body: JSON.stringify({
            distributions: distributions,
            traderId: activeTraderId,
            addToHistory: true,
            masterTradeLog: masterTradeLog
          })
        })
      const res = await req.json()
      console.log(res)
      setLoader(false)

      if (res.status === 'ok') {
        Toast.fire({
          icon: 'success',
          title: `Profits/Losses distributed successfully!`
        })
        setShowTraderLogForm(false)
        fetchTraders()
        setIndividualAllocations({})
        setCopyTraders([])
      } else {
        Toast.fire({
          icon: 'error',
          title: `Something went wrong: ${res.error || 'Unknown error'}`
        })
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
      Toast.fire({
        icon: 'error',
        title: `Client error: ${error.message}`
      })
    }
  }

  const deleteUser = async (email) => {
    const req = await adminFetch(`${route}/api/deleteUser`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email,
      })
    })
    const res = await req.json()
    if (res.status === 200) {
      setShowDeletModal(false)
      Toast.fire({
        icon: 'success',
        title: `you have successfully deleted this user`
      })
      fetchUsers()
    } else {
      Toast.fire({
        icon: 'error',
        title: `something went wrong`
      })
    }
  }

  const deleteTrader = async (trader) => {
    const id = trader._id
    const copiers = (users || []).filter(user => user.trader === id).length
    const confirm = await Swal.fire({
      title: `Delete ${trader.firstname} ${trader.lastname}?`,
      text: copiers
        ? `${copiers} user${copiers === 1 ? ' is' : 's are'} copying this trader. This cannot be undone.`
        : 'This cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete trader',
      confirmButtonColor: 'rgb(220,70,70)',
    })
    if (!confirm.isConfirmed) return
    const req = await adminFetch(`${route}/api/deleteTrader`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: id,
      })
    })
    const res = await req.json()
    if (res.status === 200) {
      setShowDeletModal(false)
      Toast.fire({
        icon: 'success',
        title: `you have successfully deleted this trader`
      })
      fetchTraders()
    } else {
      Toast.fire({
        icon: 'error',
        title: `something went wrong`
      })
    }
  }

  const login = async () => {
    setLoader(true);
    const req = await fetch(`${route}/api/admin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email,
        password: password
      })
    });

    const res = await req.json();
    console.log(res);
    setLoader(false);

    if (res.status === 200) {
      // Save token if available
      localStorage.setItem('adminToken', res.token)
      SetShowFoarm(false)
      setShowDasboard(true)
      setLoader(true)
      fetchUsers()
      fetchTraders()
    } else {
      Toast.fire({
        icon: 'error',
        title: 'Invalid credentials'
      });
    }
  };


  const EMPTY_TRADER_FORM = {
    firstname: "",
    lastname: "",
    winRate: "",
    avgReturn: "",
    followers: "",
    rrRatio: "",
    nationality: "",
    minimumcapital: "",
  }
  const [formData, setFormData] = useState(EMPTY_TRADER_FORM);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true)

    const FormData = {
      ...formData, traderImage: showImage
    }
    try {
      const response = await axios.post(`${route}/api/createTrader`, FormData, { headers: { 'x-admin-token': localStorage.getItem('adminToken') || '' } });

      console.log("Trader created:", response.data);

      setFormData(EMPTY_TRADER_FORM);
      setShowImage(undefined)
      setLoader(false)
      Toast.fire({
        icon: 'success',
        title: `Trader successfully created!`
      })
      fetchTraders()
      openTraderLogs()
    } catch (error) {

      setLoader(false)
      Toast.fire({
        icon: 'error',
        title: `Error creating trader:, ${error}`
      })
    }
  };

  const uploadProof = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'upload');

    const req = await fetch('https://api.cloudinary.com/v1_1/duesyx3zu/image/upload', {
      method: 'POST',
      body: formData,
    });
    const res = await req.json();
    if (res) {
      setShowImage(res.secure_url);
    }
  };

  const verifyUserPdtStatus = async (id) => {
    setLoader(true)
    console.log(id)
    const req = await adminFetch(`${route}/api/verify`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: id })
    })
    const res = await req.json()
    setLoader(false)
    console.log(res)
    fetchUsers()
  }
  const approveKYC = async (user) => {
    const email = user.email;
    const result = await Swal.fire({
      title: 'Approve KYC?',
      text: 'This will approve the user\'s KYC verification',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, approve',
      cancelButtonText: 'Cancel'
    });

    if (result.isConfirmed) {
      setLoader(true);
      try {
        const response = await adminFetch(`${route}/api/admin/approveKYC`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email })
        });
        const data = await response.json();
        setLoader(false);

        if (data.status === 'ok') {
          // the approval email is sent by the backend
          Toast.fire({ icon: 'success', title: 'KYC approved and user notified' });
          fetchUsers();
        } else {
          Toast.fire({ icon: 'error', title: 'Failed to approve KYC' });
        }
      } catch (error) {
        setLoader(false);
        Toast.fire({ icon: 'error', title: 'An error occurred' });
      }
    }
  };

  const rejectKYC = async (email) => {
    const { value: reason } = await Swal.fire({
      title: 'Reject KYC',
      input: 'textarea',
      inputLabel: 'Rejection Reason',
      inputPlaceholder: 'Enter reason for rejection...',
      inputAttributes: { 'aria-label': 'Enter rejection reason' },
      showCancelButton: true,
      confirmButtonText: 'Reject',
      cancelButtonText: 'Cancel'
    });

    if (reason) {
      setLoader(true);
      try {
        const response = await adminFetch(`${route}/api/admin/rejectKYC`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, reason })
        });
        const data = await response.json();
        setLoader(false);

        if (data.status === 'ok') {
          Toast.fire({ icon: 'success', title: 'KYC Rejected' });
          fetchUsers();
        } else {
          Toast.fire({ icon: 'error', title: 'Failed to reject KYC' });
        }
      } catch (error) {
        setLoader(false);
        Toast.fire({ icon: 'error', title: 'An error occurred' });
      }
    }
  }


  const pageTitle = showUsers ? 'Users' : showCreateTrader ? 'Create Trader' : showEmails ? 'Emails' : 'Traders'

  const closeUserMenu = () => setActiveActionMenu(null)

  // Modal shell shared by credit / debit / upgrade. Called as a function, not rendered as
  // <AmountModal/>: a component defined in here would remount its input on every keystroke
  const renderAmountModal = ({ title, subtitle, actionLabel, danger, onClose, onSubmit }) => (
    <div className="adm-modal-overlay" onClick={onClose}>
      <div className="adm-modal" onClick={e => e.stopPropagation()}>
        <button className="adm-modal-close" onClick={onClose} aria-label="Close"><MdClose size={16} /></button>
        <p className="adm-modal-title">{title}</p>
        {subtitle && <p className="adm-modal-sub">{subtitle}</p>}
        <div className="adm-amount-wrap">
          <span>USD</span>
          <input type="number" placeholder="0.00" autoFocus onChange={e => setUserAmount(parseInt(e.target.value))} />
        </div>
        <div className="adm-modal-actions">
          <button className="adm-btn ghost" onClick={onClose}>Cancel</button>
          <button className={`adm-btn ${danger ? 'danger' : 'primary'}`} onClick={onSubmit}>{actionLabel}</button>
        </div>
      </div>
    </div>
  )

  return (
    <div className='admin-root'>
      {loader && <Loader />}

      {/* ── LOGIN ── */}
      {showForm && (
        <div className="adm-login-bg">
          <form className="adm-login-card" onSubmit={e => { e.preventDefault(); login() }}>
            <img src="/ollarinmirror-logo.svg" alt="Ollarin Mirror" className="adm-login-logo" />
            <p className="adm-login-sub">Admin panel — sign in to continue</p>
            <div className="adm-login-field">
              <label>Email</label>
              <input type="text" placeholder="admin@ollarinmirror.com" required
                onChange={e => setEmail(e.target.value.trim().toLowerCase())} />
            </div>
            <div className="adm-login-field">
              <label>Password</label>
              <div className="adm-login-pw-wrap">
                <input type={showPassword ? 'text' : 'password'} placeholder="••••••••" required
                  onChange={e => setPassword(e.target.value.trim())} />
                <span onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <BsEye /> : <BsEyeSlash />}
                </span>
              </div>
            </div>
            <button type="submit" className="adm-login-btn">Sign In</button>
          </form>
        </div>
      )}

      {/* ── DASHBOARD ── */}
      {showDashboard && (
        <div className="adm-layout">

          {/* SIDEBAR */}
          <aside className="adm-sidebar">
            <div className="adm-sidebar-brand">
              <img src="/ollarinmirror-logo.svg" alt="Ollarin Mirror" className="adm-brand-logo" />
            </div>
            <nav className="adm-nav">
              <button className={`adm-nav-item ${showUsers ? 'active' : ''}`} onClick={openUsers}>
                <RxDashboard size={16} /> Users
                <span className="adm-nav-count">{allUsers.length}</span>
              </button>
              <button className={`adm-nav-item ${showTraderLogs ? 'active' : ''}`} onClick={openTraderLogs}>
                <MdCandlestickChart size={16} /> Traders
                <span className="adm-nav-count">{traders.length}</span>
              </button>
              <button className={`adm-nav-item ${showCreateTrader ? 'active' : ''}`} onClick={openCreateTrader}>
                <GiReceiveMoney size={16} /> Create Trader
              </button>
              <button className={`adm-nav-item ${showEmails ? 'active' : ''}`} onClick={openEmails}>
                <FiMail size={16} /> Emails
                {emailSummary.unread > 0 && <span className="adm-nav-count">{emailSummary.unread}</span>}
              </button>
            </nav>
            {kycCounts.processing > 0 && (
              <button className="adm-sidebar-alert" onClick={() => { openUsers(); setKycFilter('processing') }}>
                <FiShield size={15} />
                <span><strong>{kycCounts.processing}</strong> KYC awaiting review</span>
              </button>
            )}
            <button className="adm-logout-btn" onClick={logout}>
              <FiLogOut size={15} /> Sign Out
            </button>
          </aside>

          {/* MOBILE BOTTOM NAV */}
          <nav className="adm-bottom-nav">
            <button className={`adm-bottom-nav-item ${showUsers ? 'active' : ''}`} onClick={openUsers}>
              <RxDashboard size={20} />
              Users
            </button>
            <button className={`adm-bottom-nav-item ${showTraderLogs ? 'active' : ''}`} onClick={openTraderLogs}>
              <MdCandlestickChart size={20} />
              Traders
            </button>
            <button className={`adm-bottom-nav-item ${showCreateTrader ? 'active' : ''}`} onClick={openCreateTrader}>
              <GiReceiveMoney size={20} />
              Create
            </button>
            <button className={`adm-bottom-nav-item ${showEmails ? 'active' : ''}`} onClick={openEmails}>
              <FiMail size={20} />
              Emails
            </button>
            <button className="adm-bottom-nav-logout" onClick={logout}>
              <FiLogOut size={20} />
              Logout
            </button>
          </nav>

          {/* MAIN */}
          <div className="adm-main">

            {/* TOPBAR */}
            <header className="adm-topbar">
              <div className="adm-topbar-left">
                <h2 className="adm-page-title">{pageTitle}</h2>
                {showUsers && <span className="adm-count-badge">{allUsers.length} total</span>}
                {showTraderLogs && <span className="adm-count-badge">{traders.length} total</span>}
              </div>
              <div className="adm-topbar-right">
                <button className="adm-icon-btn" onClick={refresh} title="Refresh data" aria-label="Refresh data">
                  <FiRefreshCw size={15} />
                </button>
                <div className="adm-avatar">A</div>
              </div>
            </header>

            {/* CONTENT */}
            <div className="adm-content">

              {/* ── MODALS ── */}
              {composeTo && (
                <ComposeModal
                  route={route}
                  adminFetch={adminFetch}
                  users={allUsers}
                  quota={emailSummary.quota}
                  initialTo={composeTo}
                  onClose={() => setComposeTo(null)}
                  onSent={fetchEmailSummary}
                />
              )}
              {showDeleteModal && (
                <div className="adm-modal-overlay" onClick={() => setShowDeletModal(false)}>
                  <div className="adm-modal narrow" onClick={e => e.stopPropagation()}>
                    <button className="adm-modal-close" onClick={() => setShowDeletModal(false)} aria-label="Close"><MdClose size={16} /></button>
                    <div className="adm-modal-warning">⚠</div>
                    <p className="adm-modal-title center">Delete user?</p>
                    <p className="adm-modal-sub center">
                      <strong>{activeEmail}</strong> and all their data will be permanently removed. This cannot be undone.
                    </p>
                    <div className="adm-modal-actions">
                      <button className="adm-btn ghost" onClick={() => setShowDeletModal(false)}>Cancel</button>
                      <button className="adm-btn danger" onClick={() => deleteUser(activeEmail)}>Delete</button>
                    </div>
                  </div>
                </div>
              )}

              {showUpgradeModal && renderAmountModal({
                title: 'Add profit', subtitle: activeEmail, actionLabel: 'Apply',
                onClose: () => setShowUpgradeModal(false), onSubmit: upgradeUser,
              })}
              {showModal && renderAmountModal({
                title: 'Credit account', subtitle: email, actionLabel: 'Credit',
                onClose: () => setShowModal(false), onSubmit: () => { creditUser(); setShowModal(false) },
              })}
              {debitModal && renderAmountModal({
                title: 'Debit account', subtitle: email, actionLabel: 'Debit', danger: true,
                onClose: () => setDebitModal(false), onSubmit: () => { debitUser(); setDebitModal(false) },
              })}

              {/* Trade log modal */}
              {showTraderLogForm && (
                <div className="adm-modal-overlay" onClick={() => setShowTraderLogForm(false)}>
                  <div className="adm-modal wide" onClick={e => e.stopPropagation()}>
                    <button className="adm-modal-close" onClick={() => setShowTraderLogForm(false)} aria-label="Close"><MdClose size={16} /></button>
                    <p className="adm-modal-title">Log a trade</p>
                    <p className="adm-modal-sub">{activeTraderName} · {copyTraders.length} copier{copyTraders.length === 1 ? '' : 's'}</p>

                    <div className="adm-form-field">
                      <label>Trading pair</label>
                      <select className="adm-form-input" value={activeTrader.pair || ''}
                        onChange={e => setActiveTrader({ ...activeTrader, pair: e.target.value })}>
                        <option value="" disabled>Select a pair…</option>
                        {TRADE_PAIRS.map(({ group, pairs }) => (
                          <optgroup key={group} label={group}>
                            {pairs.map(([value, label]) => <option key={`${group}-${value}`} value={value}>{label}</option>)}
                          </optgroup>
                        ))}
                      </select>
                    </div>

                    {copyTraders.length === 0 ? (
                      <p className="adm-muted-note">No users are copying this trader, so there is nobody to credit.</p>
                    ) : (
                      <>
                        <div className="adm-bulk-row">
                          <span>Apply to all</span>
                          <input type="number" placeholder="Amount" value={bulkAmount} onChange={e => setBulkAmount(e.target.value)} />
                          <select value={bulkType} onChange={e => setBulkType(e.target.value)}>
                            <option value="profit">Profit</option>
                            <option value="loss">Loss</option>
                          </select>
                          <button className="adm-btn ghost small" onClick={applyBulkAllocation}>Apply</button>
                        </div>

                        <div className="copy-traders-list-container">
                          {copyTraders.map(user => (
                            <div className="copy-trader-row" key={user._id}>
                              <div className="ct-info">
                                <span className="ct-name">{user.firstname} {user.lastname}</span>
                                <span className="ct-email">{user.email}</span>
                                <span className="ct-balance">Balance: {usd(user.funded)}</span>
                              </div>
                              <div className="ct-inputs">
                                <input
                                  type="number"
                                  placeholder="Amount"
                                  className="ct-amount-input"
                                  value={individualAllocations[user._id]?.amount || ''}
                                  onChange={(e) => setIndividualAllocations({
                                    ...individualAllocations,
                                    [user._id]: { ...individualAllocations[user._id], amount: parseFloat(e.target.value) }
                                  })}
                                />
                                <select
                                  className={`ct-type-select ${individualAllocations[user._id]?.type === 'loss' ? 'loss' : 'profit'}`}
                                  value={individualAllocations[user._id]?.type || 'profit'}
                                  onChange={(e) => setIndividualAllocations({
                                    ...individualAllocations,
                                    [user._id]: { ...individualAllocations[user._id], type: e.target.value }
                                  })}
                                >
                                  <option value="profit">Profit</option>
                                  <option value="loss">Loss</option>
                                </select>
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}

                    <div className="adm-modal-actions">
                      <button className="adm-btn ghost" onClick={() => setShowTraderLogForm(false)}>Cancel</button>
                      <button className="adm-btn primary" onClick={updateTraderLog} disabled={copyTraders.length === 0}>Save trade</button>
                    </div>
                  </div>
                </div>
              )}

              {/* User details modal */}
              {showUserDetailsModal && selectedUser && (
                <div className="adm-modal-overlay" onClick={() => setShowUserDetailsModal(false)}>
                  <div className="adm-modal wide scroll" onClick={e => e.stopPropagation()}>
                    <button className="adm-modal-close" onClick={() => setShowUserDetailsModal(false)} aria-label="Close"><MdClose size={16} /></button>
                    <div className="adm-profile-head">
                      <div className="adm-profile-avatar">
                        {`${selectedUser.firstname?.[0] || ''}${selectedUser.lastname?.[0] || ''}`.toUpperCase()}
                      </div>
                      <div>
                        <p className="adm-modal-title">{selectedUser.firstname} {selectedUser.lastname}</p>
                        <p className="adm-modal-sub">{selectedUser.email}</p>
                      </div>
                      <span className={`adm-badge ${KYC_BADGE[kycOf(selectedUser)]}`}>{KYC_LABELS[kycOf(selectedUser)]}</span>
                    </div>

                    <div className="adm-profile-stats">
                      <div><span>Balance</span><strong>{usd(selectedUser.funded)}</strong></div>
                      <div><span>Deposited</span><strong>{usd(selectedUser.totaldeposit)}</strong></div>
                      <div><span>Withdrawn</span><strong>{usd(selectedUser.totalwithdraw)}</strong></div>
                      <div><span>Profit</span><strong>{usd(selectedUser.totalprofit)}</strong></div>
                    </div>

                    <p className="adm-detail-heading">Account</p>
                    {[
                      ['Username', selectedUser.username],
                      ['Phone', selectedUser.phonenumber || '—'],
                      ['Country', selectedUser.country || '—'],
                      ['State', selectedUser.state || '—'],
                      ['City', selectedUser.city || '—'],
                      ['Postal Code', selectedUser.zipcode || '—'],
                      ['Address', selectedUser.address || '—'],
                      ['Account Type', selectedUser.accountType || '—'],
                      ['2FA', selectedUser.twoFactorEnabled ? 'Enabled' : 'Off'],
                    ].map(([label, value]) => (
                      <div className="adm-detail-row" key={label}>
                        <span>{label}</span>
                        <strong>{value}</strong>
                      </div>
                    ))}

                    <p className="adm-detail-heading">KYC details</p>
                    {[
                      ['Occupation', selectedUser.occupation || '—'],
                      ['Annual Income', selectedUser.annualIncome || '—'],
                      ['Employment Status', selectedUser.employmentStatus || '—'],
                      ['Source of Funds', selectedUser.sourceOfFunds || '—'],
                      ['Investment Experience', selectedUser.investmentExperience || '—'],
                      ['Net Worth', selectedUser.netWorth || '—'],
                      ['Nationality', selectedUser.nationality || '—'],
                      ['Date of Birth', selectedUser.dateOfBirth || '—'],
                    ].map(([label, value]) => (
                      <div className="adm-detail-row" key={label}>
                        <span>{label}</span>
                        <strong>{value}</strong>
                      </div>
                    ))}

                    {selectedUser.kycDocument && (
                      <a href={selectedUser.kycDocument} target="_blank" rel="noreferrer" className="adm-doc-link">
                        View KYC document ↗
                      </a>
                    )}

                    <div className="adm-modal-actions">
                      {kycOf(selectedUser) !== 'approved' && (
                        <button className="adm-btn success" onClick={() => { setShowUserDetailsModal(false); approveKYC(selectedUser) }}>Approve KYC</button>
                      )}
                      <button className="adm-btn ghost" onClick={() => setShowUserDetailsModal(false)}>Close</button>
                    </div>
                  </div>
                </div>
              )}

              {/* ── USERS ── */}
              {showUsers && (
                <>
                  <div className="adm-stats-row">
                    <button className={`adm-stat-card ${kycFilter === 'all' ? 'active' : ''}`} onClick={() => setKycFilter('all')}>
                      <span className="adm-stat-icon teal"><FiUsers /></span>
                      <span className="adm-stat-text"><span>Total users</span><strong>{allUsers.length}</strong></span>
                    </button>
                    <div className="adm-stat-card">
                      <span className="adm-stat-icon green"><FiDollarSign /></span>
                      <span className="adm-stat-text"><span>Total balances</span><strong>{usd(totalBalance)}</strong></span>
                    </div>
                    <button className={`adm-stat-card ${kycFilter === 'processing' ? 'active' : ''}`} onClick={() => setKycFilter('processing')}>
                      <span className="adm-stat-icon amber"><FiShield /></span>
                      <span className="adm-stat-text"><span>KYC to review</span><strong>{kycCounts.processing}</strong></span>
                    </button>
                    <button className="adm-stat-card" onClick={openTraderLogs}>
                      <span className="adm-stat-icon blue"><FiTrendingUp /></span>
                      <span className="adm-stat-text"><span>Traders</span><strong>{traders.length}</strong></span>
                    </button>
                  </div>

                  <div className="adm-toolbar">
                    <div className="adm-search">
                      <FiSearch className="adm-search-icon" />
                      <input
                        type="search"
                        placeholder="Search name, email, username or country…"
                        value={userSearch}
                        onChange={e => setUserSearch(e.target.value)}
                      />
                      {userSearch && (
                        <button className="adm-search-clear" onClick={() => setUserSearch('')} aria-label="Clear search"><FiX size={14} /></button>
                      )}
                    </div>
                    <select className="adm-sort" value={userSort} onChange={e => setUserSort(e.target.value)} aria-label="Sort users">
                      <option value="balance-desc">Balance: high to low</option>
                      <option value="balance-asc">Balance: low to high</option>
                      <option value="name">Name A–Z</option>
                    </select>
                  </div>

                  <div className="adm-chips">
                    {['all', 'processing', 'approved', 'not_submitted', 'rejected'].map(key => (
                      <button key={key} className={`adm-chip ${kycFilter === key ? 'active' : ''}`} onClick={() => setKycFilter(key)}>
                        {KYC_LABELS[key]} <span>{kycCounts[key]}</span>
                      </button>
                    ))}
                  </div>

                  <p className="adm-result-count">
                    Showing {filteredUsers.length} of {allUsers.length} user{allUsers.length === 1 ? '' : 's'}
                    {(userSearch || kycFilter !== 'all') && (
                      <button className="adm-link-btn" onClick={() => { setUserSearch(''); setKycFilter('all') }}>Clear filters</button>
                    )}
                  </p>

                  {filteredUsers.length > 0 ? (
                    <div className="adm-table-wrap">
                      <table className="adm-table">
                        <thead>
                          <tr>
                            <th>User</th>
                            <th>KYC</th>
                            <th>Balance</th>
                            <th>Trader</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredUsers.map(refer => {
                            const trader = traders.find(t => t._id === refer.trader)
                            return (
                              <tr key={refer.email}>
                                <td>
                                  <div className="adm-user-cell">
                                  <button className="adm-user-link" onClick={() => { setSelectedUser(refer); setShowUserDetailsModal(true) }}>
                                    <span className="adm-user-avatar">{`${refer.firstname?.[0] || ''}${refer.lastname?.[0] || ''}`.toUpperCase()}</span>
                                    <span>
                                      <span className="adm-user-name">{refer.firstname} {refer.lastname}</span>
                                      <span className="adm-user-meta">{refer.email}</span>
                                    </span>
                                  </button>
                                  <button className="adm-copy-btn" onClick={() => copyToClipboard(refer.email)} title="Copy email" aria-label="Copy email">
                                    <FiCopy size={12} />
                                  </button>
                                  </div>
                                </td>
                                <td>
                                  <span className={`adm-badge ${KYC_BADGE[kycOf(refer)]}`}>{KYC_LABELS[kycOf(refer)]}</span>
                                </td>
                                <td>
                                  <span className="adm-balance">{usd(refer.funded)}</span>
                                </td>
                                <td>
                                  <span className="adm-user-meta">{trader ? `${trader.firstname} ${trader.lastname}` : '—'}</span>
                                </td>
                                <td className="adm-action-cell">
                                  <div className="adm-row-actions">
                                    <button className="adm-quick-btn credit" onClick={() => { setShowModal(true); setEmail(refer.email) }}>Credit</button>
                                    <button className="adm-quick-btn debit" onClick={() => { setDebitModal(true); setEmail(refer.email) }}>Debit</button>
                                    <button
                                      className="adm-menu-btn"
                                      aria-label="More actions"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        if (activeActionMenu === refer.email) {
                                          closeUserMenu();
                                        } else {
                                          const rect = e.currentTarget.getBoundingClientRect();
                                          const dropdownHeight = 360;
                                          const spaceBelow = window.innerHeight - rect.bottom;
                                          const top = spaceBelow < dropdownHeight
                                            ? Math.max(10, rect.top - dropdownHeight - 6)
                                            : rect.bottom + 6;
                                          setDropdownPos({ top, right: window.innerWidth - rect.right });
                                          setActiveActionMenu(refer.email);
                                        }
                                      }}
                                    >
                                      <FaEllipsisH size={13} />
                                    </button>
                                  </div>

                                  {activeActionMenu === refer.email && (
                                    <div className="adm-dropdown" style={{ top: dropdownPos.top, right: dropdownPos.right }}>
                                      <button className="adm-dropdown-item" onClick={() => { setSelectedUser(refer); setShowUserDetailsModal(true); closeUserMenu() }}>View details</button>
                                      <button className="adm-dropdown-item" onClick={() => { setShowUpgradeModal(true); setActiveEmail(refer.email); closeUserMenu() }}>Add profit</button>
                                      <button className="adm-dropdown-item" onClick={() => { verifyUserPdtStatus(refer._id); closeUserMenu() }}>{refer.verified ? 'Lock live trading' : 'Unlock live trading'}</button>
                                      <button className="adm-dropdown-item" onClick={() => { approveWithdraw(refer); closeUserMenu() }}>Send withdrawal approval</button>
                                      <div className="adm-dropdown-divider" />
                                      <button className="adm-dropdown-item success" onClick={() => { approveKYC(refer); closeUserMenu() }}>Approve KYC</button>
                                      <button className="adm-dropdown-item danger" onClick={() => { rejectKYC(refer.email); closeUserMenu() }}>Reject KYC</button>
                                      <div className="adm-dropdown-divider" />
                                      <button className="adm-dropdown-item" onClick={() => { setComposeTo([refer.email.toLowerCase()]); closeUserMenu() }}>Send email</button>
                                      <button className="adm-dropdown-item danger" onClick={() => { setShowDeletModal(true); setActiveEmail(refer.email); closeUserMenu() }}>Delete user</button>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="adm-empty">
                      <p>{allUsers.length === 0 ? 'No registered users yet.' : 'No users match your search.'}</p>
                    </div>
                  )}
                </>
              )}

              {/* ── CREATE TRADER ── */}
              {showCreateTrader && (
                <div className="adm-create-trader-wrap">
                  <div className="adm-section-header">
                    <h2>New trader</h2>
                    <p>Add a copy trader to the platform. Users will see them under Copy Traders.</p>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div className="adm-form-grid">
                      <div className="adm-photo-upload">
                        <div className="adm-photo-circle">
                          {showImage ? <img src={showImage} alt="" /> : <BsImage />}
                        </div>
                        <label htmlFor="file-input" className="adm-upload-btn">
                          <RxUpload size={14} /> {showImage ? 'Change photo' : 'Upload photo'}
                          <input type="file" accept=".jpg,.png,.svg,.webp,.jpeg" id="file-input" style={{ display: 'none' }} required={!showImage} onChange={(e) => uploadProof(e.target.files[0])} />
                        </label>
                      </div>

                      {[
                        ['firstname', 'First Name', 'e.g. James', 'text'],
                        ['lastname', 'Last Name', 'e.g. Carter', 'text'],
                        ['winRate', 'Win Rate', 'e.g. 78%', 'text'],
                        ['avgReturn', 'Avg Return', 'e.g. 12%', 'text'],
                        ['followers', 'Followers', 'e.g. 3400', 'text'],
                        ['rrRatio', 'Risk / Reward Ratio', 'e.g. 1:3', 'text'],
                        ['nationality', 'Nationality', 'e.g. American', 'text'],
                        ['minimumcapital', 'Min Capital (USD)', 'e.g. 500', 'number'],
                      ].map(([field, label, placeholder, type]) => (
                        <div className="adm-form-field" key={field}>
                          <label htmlFor={`trader-${field}`}>{label}</label>
                          <input id={`trader-${field}`} type={type} name={field} className="adm-form-input"
                            placeholder={placeholder} value={formData[field]} onChange={handleChange}
                            required={field === 'firstname' || field === 'lastname'} />
                        </div>
                      ))}

                      <button type="submit" className="adm-submit-btn">Add trader</button>
                    </div>
                  </form>
                </div>
              )}

              {/* ── EMAILS ── */}
              {showEmails && <EmailsPanel route={route} adminFetch={adminFetch} users={allUsers} onSummary={setEmailSummary} />}

              {/* ── TRADERS ── */}
              {showTraderLogs && (
                <>
                  <div className="adm-toolbar">
                    <div className="adm-search">
                      <FiSearch className="adm-search-icon" />
                      <input
                        type="search"
                        placeholder="Search traders by name or nationality…"
                        value={traderSearch}
                        onChange={e => setTraderSearch(e.target.value)}
                      />
                      {traderSearch && (
                        <button className="adm-search-clear" onClick={() => setTraderSearch('')} aria-label="Clear search"><FiX size={14} /></button>
                      )}
                    </div>
                    <button className="adm-btn primary" onClick={openCreateTrader}>+ New trader</button>
                  </div>

                  <p className="adm-result-count">Showing {filteredTraders.length} of {traders.length} trader{traders.length === 1 ? '' : 's'}</p>

                  {filteredTraders.length > 0 ? (
                    <div className="adm-traders-grid">
                      {filteredTraders.map(trader => (
                        <div className="adm-trader-card" key={trader._id}>
                          <button className="adm-trader-card-delete" onClick={() => deleteTrader(trader)} title="Delete trader" aria-label="Delete trader">
                            <MdDeleteSweep size={15} />
                          </button>
                          <img src={trader.traderImage} alt="" className="adm-trader-img" />
                          <p className="adm-trader-name">{trader.firstname} {trader.lastname}</p>
                          <p className="adm-trader-sub">{trader.nationality || 'Professional Trader'}</p>
                          <span className="adm-copiers">
                            <FiUsers size={12} /> {copiersByTrader[trader._id] || 0} copier{copiersByTrader[trader._id] === 1 ? '' : 's'}
                          </span>
                          <div className="adm-trader-stats">
                            <div className="adm-trader-stat">
                              <span className="adm-trader-stat-label">Win Rate</span>
                              <span className="adm-trader-stat-value">{trader.profitrate}</span>
                            </div>
                            <div className="adm-trader-stat">
                              <span className="adm-trader-stat-label">Avg Return</span>
                              <span className="adm-trader-stat-value">{trader.averagereturn}</span>
                            </div>
                            <div className="adm-trader-stat">
                              <span className="adm-trader-stat-label">Min Capital</span>
                              <span className="adm-trader-stat-value">${trader.minimumcapital}</span>
                            </div>
                          </div>
                          <button className="adm-update-log-btn" onClick={() => openTraderLogForm(trader)}>Log a trade</button>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="adm-empty">
                      <p>{traders.length === 0 ? 'No traders yet. Create one to get started.' : 'No traders match your search.'}</p>
                    </div>
                  )}
                </>
              )}

            </div>
          </div>
        </div>
      )}

    </div>
  )
}

export default Admindashboard
